import React from "react";
import { Link } from "react-router-dom";
import "../styles/Blog.css";
import useScrollFade from "../useScrollFade";

const BlogCard = ({ post }) => {
  const isVisible = useScrollFade();

  return (
    <div className={`blog-card fade-in-element ${isVisible ? "visible" : ""}`}>
      <img src={post.image} alt={post.title} />
      <div className="blog-card-content">
        <h3>{post.title}</h3>
        <p>{post.summary}</p>
        <Link to={`/blog/${post.id}`} className="blog-card-button">Leer más</Link>
      </div>
    </div>
  );
};

export default BlogCard;